import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useRolesContext } from "../../../hooks/roles/useRolesContext";
import { VIRTUAL_SECURITY_TYPE } from "../../../helper/licenseHelper";
import { useAllProducts } from "../../../hooks/useAllProduts";

type ProductsFilterProps = {
  onChange: (value: string) => void;
  value?: string;
  onClear?: (value?: any) => void;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const ProductsFilter: React.FC<ProductsFilterProps> = ({
  value,
  onChange,
  onClear,
}) => {
  const { t } = useTranslation();
  const allProducts = useAllProducts();
  const { roles } = useRolesContext();

  let searchAccessFilterListArray: string[] = [];
  searchAccessFilterListArray =
    roles?.VIRTUAL_SECURITY_SEARCH_ACCESS_LIST_FILTER_LIST?.toString()?.split(
      ","
    ) ?? [];
  searchAccessFilterListArray = searchAccessFilterListArray.map((value) =>
    value.trim()
  );

  const products = allProducts?.products.filter((p) => {
    if (
      roles.VIRTUAL_SECURITY_SEARCH_ACCESS_LIST &&
      roles.VIRTUAL_SECURITY_SEARCH_ACCESS_LIST_FILTER_LIST &&
      roles.VIRTUAL_SECURITY_SEARCH_ACCESS_LIST_FILTER_LIST != ""
    ) {
      if (p.code) {
        return (
          p.security_type === VIRTUAL_SECURITY_TYPE &&
          searchAccessFilterListArray.includes(p.code)
        );
      }
    } else {
      return p.security_type === VIRTUAL_SECURITY_TYPE;
    }
  });

  const productsOptions = products.map((product) => ({
    value: product.code,
    label: product.name,
  }));

  return (
    <SelectBoxWrapper>
      <Select
        // mode="multiple"
        allowClear
        placeholder={t("licenses.basic.search.product.title")}
        style={{ width: "100%" }}
        maxTagCount={1}
        options={productsOptions}
        onChange={onChange}
        value={value}
        onClear={(value?: any) => {
          if (onClear) {
            onClear(value);
          }
        }}
      />
    </SelectBoxWrapper>
  );
};
